/**
 * WS-HF shared login — which pages the app may open in the system browser (desktop) or a new
 * tab (web), through `PlatformIO.openExternal`.
 *
 * An ALLOWLIST, not a scheme check. The only page this surface exists for is the company
 * Higgsfield sign-in (`POST /api/admin/ai/higgsfield/mcp/login` → `authorize_url`), and a
 * web view that could open any link in the system browser could send the operator anywhere.
 * The Rust command behind the desktop bridge (`genz_open_external`) holds the same list, so a
 * page that skips this function is refused there too.
 */

/** Registrable domains whose HTTPS pages may be opened; each one's subdomains are included. */
export const EXTERNAL_HOSTS: readonly string[] = ["higgsfield.ai"];

/** True for an `https:` URL on an allowed domain, with no credentials and no custom port. */
export function isAllowedExternalUrl(raw: string): boolean {
  let url: URL;
  try {
    url = new URL(raw);
  } catch {
    return false;
  }
  if (url.protocol !== "https:") return false;
  if (url.username || url.password || url.port) return false;
  const host = url.hostname.toLowerCase();
  return EXTERNAL_HOSTS.some((d) => host === d || host.endsWith(`.${d}`));
}

/** The one sentence both platforms refuse with. */
export function refusedExternalUrl(): Error {
  return new Error("Refused to open that page: only Higgsfield sign-in pages can be opened from the app.");
}
